// src/services/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyDNHLhgA6MNnjEw709UlPMF2z3D_7D0xZE",
    authDomain: "vikas-mandal-51196.firebaseapp.com",
    projectId: "vikas-mandal-51196",
    storageBucket: "vikas-mandal-51196.firebasestorage.app",
    messagingSenderId: "997011445959",
    appId: "1:997011445959:web:54987365cfae98db6b86e2",
    measurementId: "G-1KRVKWKQV1"
};

// Initialize Firebase App instance
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging (FCM)
export const messaging = getMessaging(app);

/**
 * Standard utility function to fetch the FCM Push Notification Token
 * @returns {Promise<string|null>}
 */

export const fetchFcmToken = async () => {
    try {
        if (!('serviceWorker' in navigator)) {
            console.error("Service workers are not supported in this browser context.");
            return null;
        }

        // 1. Resolve your subfolder path variables dynamically
        const baseFolder = '/';
        const swPath = `${baseFolder}/firebase-messaging-sw.js`.replace(/\/+/g, '/');
        const swScope = baseFolder.endsWith('/') ? baseFolder : `${baseFolder}/`;

        console.log("Registering Service Worker from path:", swPath);

        // 2. Register the subdirectory worker instance
        const registration = await navigator.serviceWorker.register(swPath, {
            scope: swScope
        });

        // 3. CRITICAL: Wait for the worker to finish installing and become completely active
        // If passed while still initializing, Firebase will reject it and trigger the default fallback.
        await navigator.serviceWorker.ready;

        console.log("Service Worker is fully ready. Passing registration to FCM...");

        /*if (registration.installing) {
            await new Promise((resolve) => {
                registration.installing.addEventListener('statechange', (e) => {
                    if (e.target.state === 'activated') resolve();
                });
            });
        }*/

        console.log("Service Worker is active. Generating token...");
        // 4. Request token with exact case-sensitive options key match
        const token = await getToken(messaging, {
            vapidKey: "BLepWyeu_n68N1JYP4x4VXqR6mHSEpMlxIhGLs7L0mL2UOIK1Bhq_G5ZK6lPYo-oM833l0oyNse02Gx2UB3SWk0",
            serviceWorkerRegistration: registration // <-- MUST be spelled exactly like this
        });
        console.log("FCM Token generated successfully:", token);
        return token;
    } catch (error) {
        console.error("An error occurred while retrieving the FCM token:", error);
        return null;
    }
};
